import React from 'react';
import CurrencyFormat from 'react-currency-format';

// The period total behind the number the drill-down was opened from, per source and together.
//
// The number in the report counts sports and games legs both, so a total covering one of them is a
// figure that reads as the whole period while covering half of it - and the reader has to switch
// segments to learn the other source's contribution. This is one call read once when the modal opens,
// so the row is the same whichever segment is open and cannot move as the segment changes.
//
// The sports side is itself two populations: our own bets and the WeGa sports bets priced off the same
// sports stake settings. They are shown as separate lines rather than one folded Sports row, so a screen
// whose segments list one population each has a line covering exactly what it lists - and so the rows
// above still add up: Sports + WeGa sport = Sports Total, and Sports Total + Games = Grand Total.
const Money = ({ value }) => (
  <CurrencyFormat
    value={value}
    decimalScale={2}
    displayType={'text'}
    thousandSeparator={true}
    fixedDecimalScale={true}
  />
);

const ReportGrandTotal = ({ total }) => {
  if (!total) return null;
  const legs = [
    { label: 'Sports', leg: total.sports },
    { label: 'WeGa sport', leg: total.wegaSports },
    // the figure the sports Report's number is: own sport plus WeGa sport, summed server-side so no
    // client adds money and repeats a rounding rule
    { label: 'Sports Total', leg: total.sportsTotal, strong: true },
    { label: 'Games', leg: total.games },
    { label: 'Grand Total', leg: total.combined, strong: true },
  ].filter((row) => row.leg);
  if (legs.length === 0) return null;

  return (
    <table className="table table-sm table-striped table-bordered balance-grand-total mb-2">
      {/* The same head the two bet lists wear, so the block reads as one table family with them. */}
      <thead className="text-center thead-dark">
        <tr>
          <th scope="col" />
          <th scope="col">Amount</th>
          <th scope="col">Turnover</th>
          <th scope="col">Comm</th>
          <th scope="col">Net Amt</th>
          <th scope="col">Winning</th>
        </tr>
      </thead>
      <tbody>
        {legs.map(({ label, leg, strong }) => (
          <tr key={label} className={strong ? 'font-weight-bold' : ''}>
            <td className="text-nowrap">{label}</td>
            <td className="text-right">
              <Money value={leg.totalAmount} />
            </td>
            <td className="text-right">
              <Money value={leg.totalTurnover} />
            </td>
            <td className="text-right">
              <Money value={leg.totalCommission} />
            </td>
            <td className="text-right">
              <Money value={leg.totalNetAmount} />
            </td>
            <td className={`text-right ${leg.totalWinning < 0 ? 'text-danger' : ''}`}>
              <Money value={leg.totalWinning} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ReportGrandTotal;
